/** A small derby ticket, drawn in the current text colour (emoji tickets are missing from some fonts). */
export function TicketIcon() {
  return (
    <svg class="ticket-icon" viewBox="0 0 24 16" width="1.25em" height="0.85em" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M2 1h20a1 1 0 0 1 1 1v3.2a2.8 2.8 0 0 0 0 5.6V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3.2a2.8 2.8 0 0 0 0-5.6V2a1 1 0 0 1 1-1Zm14 2v2h1.5V3H16Zm0 4v2h1.5V7H16Zm0 4v2h1.5v-2H16ZM4.5 5.5v1.3h8V5.5h-8Zm0 3.7v1.3h6V9.2h-6Z" fill-rule="evenodd" />
    </svg>
  );
}
